// src/realtime/sync.ts
import type { QueryClient } from "@tanstack/react-query";

import type { components } from "@/api/schema";

import type { RealtimeEvent } from "./types";

type Reading = components["schemas"]["ReadingPublic"];

/**
 * ترجمة أحداث الخادم إلى تحديثات لكاش TanStack Query. الحدث خفيف، فالقيم الصغيرة
 * (قراءة عداد) تُدرج مباشرة، وأي شيء آخر يُبطَل كاشه فتجلبه الواجهة بطلب عادي محكوم بالصلاحيات.
 */
export function applyEvent(qc: QueryClient, ev: RealtimeEvent): void {
  const pid = ev.project_id;
  const d = ev.data as Record<string, unknown>;
  switch (ev.type) {
    case "meter.reading_recorded": {
      if (!pid) return;
      const reading: Reading = {
        id: ev.entity_id,
        meter_id: String(d.meter_id),
        reading_value: Number(d.reading_value),
        unit_of_measure: String(d.unit_of_measure),
        consumption_delta: (d.consumption_delta as number | null) ?? null,
        recorded_at: String(d.recorded_at),
        source: d.source as Reading["source"],
        is_anomalous: Boolean(d.is_anomalous),
      };
      qc.setQueryData<Reading[]>(["projects", pid, "meters", reading.meter_id, "readings"], (old) =>
        old && !old.some((r) => r.id === reading.id) ? [reading, ...old] : old,
      );
      void qc.invalidateQueries({ queryKey: ["projects", pid, "meters", reading.meter_id, "connection"] });
      return;
    }
    case "meter.alert_opened":
      void qc.invalidateQueries({ queryKey: ["dashboard"] });
      return;
    case "payment.status_changed":
      if (pid) void qc.invalidateQueries({ queryKey: ["projects", pid, "contracts", String(d.contract_id), "payments"] });
      void qc.invalidateQueries({ queryKey: ["dashboard"] });
      return;
    case "notification.created":
    case "notification.updated":
      void qc.invalidateQueries({ queryKey: ["notifications"] });
      return;
    case "outbox.updated":
      void qc.invalidateQueries({ queryKey: ["outbox"] });
      return;
  }
}
